<template>
  <AuthenticatedLayout>
    <div class="row">
      <div class="col-12">
        <div class="card welcome-card shadow-lg border-0">
          <div class="welcome-glow welcome-glow--1"></div>
          <div class="welcome-glow welcome-glow--2"></div>
          <div class="card-body p-3 p-md-5 position-relative">
            <div class="text-center mb-5">
              <div class="welcome-icon mb-4">
                <i class="fas fa-hand-sparkles fa-4x text-gradient text-info"></i>
              </div>
              <h2 class="text-gradient text-info mb-3">
                Bem-vindo ao Valora!
              </h2>
              <p class="lead text-muted mb-4">
                Seu sistema de gestão de produtos, categorias e supermercados
              </p>
            </div>

            <div class="row mt-5">
              <div class="col-lg-4 col-md-6 mb-4">
                <div class="card card-hover h-100 border-0 shadow-sm">
                  <div class="card-body text-center p-4">
                    <div class="icon-badge mb-3">
                      <i class="fas fa-tags"></i>
                    </div>
                    <h5 class="mb-3">Categorias</h5>
                    <p class="text-muted mb-4">
                      Gerencie e organize suas categorias de produtos de forma eficiente
                    </p>
                    <router-link
                      :to="{ name: 'Categorias' }"
                      class="btn btn-custom-gradient btn-sm"
                    >
                      <i class="fas fa-arrow-right me-1"></i>
                      Acessar Categorias
                    </router-link>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 col-md-6 mb-4">
                <div class="card card-hover h-100 border-0 shadow-sm">
                  <div class="card-body text-center p-4">
                    <div class="icon-badge mb-3">
                      <i class="fas fa-box"></i>
                    </div>
                    <h5 class="mb-3">Produtos</h5>
                    <p class="text-muted mb-4">
                      Cadastre, visualize e gerencie todos os seus produtos com facilidade
                    </p>
                    <router-link
                      :to="{ name: 'ProdutosCatalogo' }"
                      class="btn btn-custom-gradient btn-sm"
                    >
                      <i class="fas fa-arrow-right me-1"></i>
                      Acessar Produtos
                    </router-link>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 col-md-6 mb-4">
                <div class="card card-hover h-100 border-0 shadow-sm">
                  <div class="card-body text-center p-4">
                    <div class="icon-badge mb-3">
                      <i class="fas fa-store"></i>
                    </div>
                    <h5 class="mb-3">Supermercados</h5>
                    <p class="text-muted mb-4">
                      Gerencie informações sobre supermercados e seus endereços
                    </p>
                    <router-link
                      :to="{ name: 'Supermercados' }"
                      class="btn btn-custom-gradient btn-sm"
                    >
                      <i class="fas fa-arrow-right me-1"></i>
                      Acessar Supermercados
                    </router-link>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-5">
              <div class="col-12">
                <div class="card bg-gradient-info border-0 shadow-lg">
                  <div class="card-body p-4">
                    <div class="row align-items-center">
                      <div class="col-md-8">
                        <h5 class="text-white mb-2">
                          <i class="fas fa-info-circle me-2"></i>
                          Começando a usar o sistema
                        </h5>
                        <p class="text-white opacity-8 mb-0">
                          Use o menu lateral para navegar entre as diferentes seções do sistema.
                          Cada módulo oferece funcionalidades completas para gerenciar seus dados.
                        </p>
                      </div>
                      <div class="col-md-4 text-md-end mt-3 mt-md-0 d-none d-md-block">
                        <i class="fas fa-arrow-left fa-2x text-white opacity-6"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </AuthenticatedLayout>
</template>

<script>
import AuthenticatedLayout from "@/components/AuthenticatedLayout.vue";

export default {
  name: "Welcome",
  components: {
    AuthenticatedLayout,
  },
};
</script>

<style scoped>
.welcome-icon {
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-20px);
  }
}

.welcome-card {
  position: relative;
  overflow: hidden;
  border-radius: 1.25rem;
}

.welcome-card > .card-body {
  position: relative;
  z-index: 1;
}

.welcome-glow {
  position: absolute;
  border-radius: 50%;
  filter: blur(60px);
  opacity: 0.18;
  pointer-events: none;
  z-index: 0;
}

.welcome-glow--1 {
  width: 260px;
  height: 260px;
  top: -80px;
  right: -60px;
  background: #17c1e8;
}

.welcome-glow--2 {
  width: 220px;
  height: 220px;
  bottom: -70px;
  left: -50px;
  background: #20c997;
}

.card-hover {
  position: relative;
  transition: all 0.3s ease;
  cursor: pointer;
}

.card-hover:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(23, 193, 232, 0.15) !important;
}

.icon-badge {
  width: 72px;
  height: 72px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  background: linear-gradient(310deg, rgba(23, 193, 232, 0.12) 0%, rgba(32, 201, 151, 0.12) 100%);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.icon-badge i {
  font-size: 1.75rem;
  background: linear-gradient(310deg, #17c1e8 0%, #20c997 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.card-hover:hover .icon-badge {
  transform: scale(1.08);
  box-shadow: 0 6px 18px rgba(23, 193, 232, 0.25);
}

.btn-custom-gradient {
  background: linear-gradient(310deg, #17c1e8 0%, #20c997 100%);
  border: none;
  color: white;
  font-weight: 600;
  transition: all 0.3s ease;
}

.btn-custom-gradient:hover {
  background: linear-gradient(310deg, #15a8d1 0%, #1bb88a 100%);
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(23, 193, 232, 0.3);
}

.btn-custom-gradient:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(23, 193, 232, 0.3);
}

.text-gradient.text-info {
  background: linear-gradient(310deg, #17c1e8 0%, #20c997 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.bg-gradient-info {
  background: linear-gradient(310deg, #17c1e8 0%, #20c997 100%) !important;
}
</style>

